import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import GasDetailTable from './gasDetailTable/GasDetailTable';
import GasDetailSearchBar from './gasDetailSearchBar/GasDetailSearchBar';

const GasDetail = (props) => {

  const gasCriterion = useSelector((store) => store.criterion).gas;
  const [searchMap, setSearchMap] = useState({
    date: new Date(),
    moduleIdx: 0,
    beginTime: 0,
    endTime: 24,
    autoReloadTime: 0,
    moduleScn: 0,
  });

  return (
    <section>
      <GasDetailSearchBar searchMap={searchMap} setSearchMap={setSearchMap} />
      <GasDetailTable flag={props.flag} searchMap={searchMap} gasCriterion={gasCriterion} />
    </section>
  );
};

export default GasDetail;
